import { SeuApiConverter, SeuCanvas, SeuCanvasApi } from '@seu-types';

export const canvasConverter: SeuApiConverter<SeuCanvas, SeuCanvasApi> = {
  fromApi: (input) => {
    const canvas: SeuCanvas = {
      canvasStreams: input.canvasStreams.map((canvasStream) => {
        return {
          ...canvasStream,
          inputStreamId: canvasStream.inputStreamId
            ? String(canvasStream.inputStreamId)
            : null,
          outputFromComponentId: canvasStream.outputFromComponentId
            ? String(canvasStream.outputFromComponentId)
            : null,
          inputForComponentId: canvasStream.inputForComponentId
            ? String(canvasStream.inputForComponentId)
            : null,
        };
      }),
      components: input.components.map((component) => {
        return {
          ...component,
          componentId: String(component.componentId),
        };
      }),
    };

    return canvas;
  },
  toApi: (input) => {
    const canvas: SeuCanvasApi = {
      canvasStreams: input.canvasStreams.map((canvasStream) => {
        return {
          ...canvasStream,
          // null, because of one-dimensional canvas we dont need it yet, value is set in backend
          inputStreamId: null,
          outputFromComponentId: canvasStream.outputFromComponentId
            ? Number(canvasStream.outputFromComponentId)
            : null,
          inputForComponentId: canvasStream.inputForComponentId
            ? Number(canvasStream.inputForComponentId)
            : null,
        };
      }),
      components: input.components.map((component) => {
        return {
          ...component,
          componentId: Number(component.componentId),
        };
      }),
    };
    return canvas;
  },
};
